import { RingFinishEnum } from '@jouzen/ecom-components/v3/enums/ringFinish';

import type { EyebrowConfig } from '@/app/components/Eyebrow/types';
import { STORE_POP_PATHNAME } from '@/app/consts/pathnames';
import { RingStyleEnum } from '@/app/enums/RingStyleEnum';
import usePathnameWithoutLocale from '@/app/hooks/usePathnameWithoutLocale';

const HARDWARE_PDP_ROUTES = [
  `${STORE_POP_PATHNAME}/${RingStyleEnum.OuraRing4}/${RingFinishEnum.BrushedSilver}`,
  `${STORE_POP_PATHNAME}/${RingStyleEnum.OuraRing4}/${RingFinishEnum.Black}`,
  `${STORE_POP_PATHNAME}/${RingStyleEnum.OuraRing4}/${RingFinishEnum.Gold}`,
  `${STORE_POP_PATHNAME}/${RingStyleEnum.OuraRing4}/${RingFinishEnum.RoseGold}`,
  `${STORE_POP_PATHNAME}/${RingStyleEnum.OuraRing4}/${RingFinishEnum.Silver}`,
  `${STORE_POP_PATHNAME}/${RingStyleEnum.OuraRing4}/${RingFinishEnum.Stealth}`,
  `${STORE_POP_PATHNAME}/${RingStyleEnum.Ceramic}/${RingFinishEnum.Midnight}`,
  `${STORE_POP_PATHNAME}/${RingStyleEnum.Ceramic}/${RingFinishEnum.Tide}`,
  `${STORE_POP_PATHNAME}/${RingStyleEnum.Ceramic}/${RingFinishEnum.Petal}`,
  `${STORE_POP_PATHNAME}/${RingStyleEnum.Ceramic}/${RingFinishEnum.Cloud}`,
];

export interface UseEyebrowConfig {
  hasActiveStatsigConfig: boolean;
  hasDiscountMessage: boolean;
  statsigValue: EyebrowConfig;
}

export enum EyebrowMessageEnum {
  STATSIG_MESSAGE = 'statsig',
  PDP_HARDWARE_MESSAGE = 'pdpHardware',
  AFFILIATE_MESSAGE = 'affiliate',
}

const useEyebrowConfig = ({
  hasActiveStatsigConfig,
  hasDiscountMessage,
  statsigValue,
}: UseEyebrowConfig): EyebrowMessageEnum => {
  const pathnameWithoutLocale = usePathnameWithoutLocale();

  const isHardwarePDPRoute = HARDWARE_PDP_ROUTES.includes(
    pathnameWithoutLocale,
  );
  const routes = statsigValue.routes ?? [];
  const activeConfigPath = routes.length
    ? routes.includes(pathnameWithoutLocale)
    : pathnameWithoutLocale === '/';

  if (hasDiscountMessage && isHardwarePDPRoute) {
    return EyebrowMessageEnum.PDP_HARDWARE_MESSAGE;
  }

  if (hasActiveStatsigConfig && activeConfigPath) {
    return EyebrowMessageEnum.STATSIG_MESSAGE;
  }

  return EyebrowMessageEnum.AFFILIATE_MESSAGE;
};

export default useEyebrowConfig;
